<style lang="scss">
    $scarlet: #C41B53;
    $scarletLight: #E0B9C6;
    $taBorderRadius: 8px;

    .consultant-tools-spotlight.arrow-collapse.dropdown{
        background-color: transparent;
        border-radius: $taBorderRadius;
        padding: 1rem 2rem;
        border: solid 2px $scarletLight;
        margin-top: 1.75rem;
        counter-reset: consultant-tools-counter;

        & > .trigger {
            color: $scarlet;
            // & > div {

                & > .arrow:before {
                    color: $scarlet;
                }

                & > .trigger-label{
                    vertical-align: middle;
                    line-height: 36px;
                    float: none;
                    color: $scarlet;
                    // font-weight: normal;

                    & > .consultant-tools-icon {
                        position: relative;
                        top: 7px;
                        display: inline-block;
                        width: 46px;
                        height: 36px;
                        margin-right: 1rem;

                        background: url(~public@/images/ta-resources/scarlet_lightbulb.png) 0 0 no-repeat;
                    }
                }
            // }
        }
        & .collapsed-content {
            & h4, h5 {
                color: $scarlet !important;
            }

            ol {
                padding-inline-start: .25rem;
                list-style: none;
            }
            ol > li {
                counter-increment: consultant-tools-counter;
            }
            ol > li::before {
                content: counter(consultant-tools-counter)'. ' ;
                font-weight: 600;
                color: $scarlet;
            }
        }
    }

    .consultant-tools-spotlight.collapsed-content.collapsed-content h4{
        color: $scarlet;
    }
</style>

<template>
    <arrow-collapse :visible="visible" :accordion="accordion" class="consultant-tools-spotlight w-100" :show-line="false" :variant="null">
        <template #trigger-label>
            <span class="consultant-tools-icon"></span>
            Consultant Tools Spotlight
        </template>
        <template #collapsed-content>
            <slot></slot>
        </template>
    </arrow-collapse>
</template>

<script>
    import ArrowCollapse from '../ArrowCollapse.vue'

    export default {
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            accordion: {
                type: String,
                default: null
            }            
        },
        components: {
            ArrowCollapse
        },
        data() {
            return {}
        },
        methods: {}
    
}
</script>